<template>

<div class="metrics" :data-count="count">

    <div class="metrics-title" v-if="title">{{ title }}</div>

    <div class="metrics-wrapper">

        <slot></slot>

    </div>

</div>

</template>

<script>

export default {

    props: ['count', 'title']

}

</script>

<style scoped>

.metrics {
    padding: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

.metrics-title {
    font-size: 14px;
    line-height: 16px;
    color: #fff;
    font-weight: 300;
    margin-bottom: 10px;
}

.metrics-wrapper {
    display: grid;
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) minmax(0, 1fr);
    grid-gap: 1px;
}

.metrics >>> .metric:nth-child(1) {
    border-top-left-radius: 4px;
}

.metrics[data-count="2"] >>> .metric:nth-child(1) {
    border-bottom-left-radius: 4px;
}

.metrics[data-count="2"] >>> .metric:nth-child(2) {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.metrics[data-count="3"] >>> .metric:nth-child(1) {
    border-bottom-left-radius: 4px;
}

.metrics[data-count="3"] >>> .metric:nth-child(3) {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.metrics[data-count="5"] >>> .metric:nth-child(3) {
    border-top-right-radius: 4px;
    border-bottom-right-radius: 4px;
}

.metrics[data-count="5"] >>> .metric:nth-child(4) {
    border-bottom-left-radius: 4px;
}

.metrics[data-count="5"] >>> .metric:nth-child(5) {
    border-bottom-right-radius: 4px;
}

.metrics[data-count="6"] >>> .metric:nth-child(3) {
    border-top-right-radius: 4px;
}

.metrics[data-count="6"] >>> .metric:nth-child(4) {
    border-bottom-left-radius: 4px;
}

.metrics[data-count="6"] >>> .metric:nth-child(6) {
    border-bottom-right-radius: 4px;
}

</style>